export const Colors = [
    {
        label: 'Da cam',
        option_id: 187,
        value: '#ffa200',
    },
    {
        label: 'Tím đậm',
        option_id: 189,
        value: '#b700ff',
    },
    {
        label: 'Xanh lam',
        option_id: 235,
        value: '#00d5ff',
    },
    {
        label: 'Vàng',
        option_id: 2301,
        value: '#fce341',
    },
    {
        label: 'Trắng',
        option_id: 2302,
        value: '#ffffff',
    },
    {
        label: 'Đỏ',
        option_id: 2303,
        value: '#ff0000',
    },
    {
        label: 'Nâu',
        option_id: 2304,
        value: '#945d34',
    },
    {
        label: 'Hồng',
        option_id: 2305,
        value: '#ffbfcd',
    },
    {
        label: 'Màu Xám',
        option_id: 2306,
        value: '#a8a8a8',
    },
    {
        label: 'Xanh lục',
        option_id: 2308,
        value: '#3f9c11',
    },
    {
        label: 'Đen',
        option_id: 2309,
        value: '#000000',
    },
    {
        label: 'Trắng hồng',
        option_id: 2359,
        value: '/t/r/trang-hong.jpg',
    },
    {
        label: 'Trắng xanh',
        option_id: 2360,
        value: '/t/r/trang-xanh_2.jpg',
    },
    {
        label: 'Xanh dương',
        option_id: 2435,
        value: '#0073ff',
    },
    {
        label: 'Xanh lá',
        option_id: 2457,
        value: '#aef35a',
    },
    {
        label: 'Inox',
        option_id: 2523,
        value: '#c9c9c9',
    },
    {
        label: 'Xanh lơ',
        option_id: 2524,
        value: '#00f7ff',
    },
    {
        label: 'Mận đỏ',
        option_id: 2527,
        value: '#b30606',
    },
    {
        label: 'Cốm - Cam',
        option_id: 2533,
        value: '#5eff00',
    },
    {
        label: 'Màu be',
        option_id: 2558,
        value: '#ffe5b2',
    },
    {
        label: 'Xanh ngọc',
        option_id: 2560,
        value: '#00fcbd',
    },
    {
        label: 'Xanh rêu',
        option_id: 2618,
        value: '#6a7a6d',
    },
    {
        label: 'Xám',
        option_id: 2619,
        value: '#a8a8a8',
    },
    {
        label: 'Màu ghi',
        option_id: 2621,
        value: '#808080',
    },
    {
        label: 'Trắng - Vàng',
        option_id: 2700,
        value: '/v/a/vang-trang_1.jpg',
    },
    {
        label: 'Trắng - Đỏ',
        option_id: 2701,
        value: '/d/o/do-trang.jpg',
    },
    {
        label: 'Xanh dương nhạt',
        option_id: 2743,
        value: '#99ccff',
    },
    {
        label: 'Trắng - Xanh đậm',
        option_id: 2773,
        value: '/t/r/trang-xanh.jpg',
    },
    {
        label: 'Nâu cam',
        option_id: 2774,
        value: '#c8b4af',
    },
    {
        label: 'Hồng nhạt',
        option_id: 2794,
        value: '#ffe5f1',
    },
    {
        label: 'Tím nhạt',
        option_id: 2880,
        value: '#e37ef7',
    },
    {
        label: 'Trắng - Cam',
        option_id: 2939,
        value: '#ff9019',
    },
    {
        label: 'Cam nhạt',
        option_id: 3007,
        value: '#ffe8d6',
    },
    {
        label: 'Xanh mint',
        option_id: 3108,
        value: '#9bc4c6',
    },
    {
        label: 'Trắng Ghi',
        option_id: 3154,
        value: '#dbdbdb',
    },
];
